const themeSliderSections = document.querySelectorAll('.theme-slider');

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

themeSliderSections.forEach((section, sectionIndex) => {
	const swiperElement = section.querySelector('.swiper-themes');
	const sliderId = swiperElement.id;

	// Set ID on swiper element if not present
	if (!swiperElement.id) {
		swiperElement.id = sliderId;
	}

	const swiper = new Swiper(swiperElement, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 32,
		loop: false,
		navigation: {
			nextEl: section.querySelector('.slider-button-next'),
			prevEl: section.querySelector('.slider-button-prev'),
		},
		pagination: {
			el: section.querySelector('.slider-pagination'),
			clickable: true,
			bulletElement: 'button',
			renderBullet: function (index, className) {
				return `
					<button 
						type="button" 
						class="slider-pagination-bullet ${className}" 
						role="tab"
						aria-label="Ga naar slide ${index + 1}"
						aria-controls="${sliderId}-slide-${index + 1}"
						aria-selected="${index === 0 ? 'true' : 'false'}"
						${index === 0 ? 'aria-current="true"' : ''}
					>
					<span class="sr-only">${index + 1}</span>
					</button>`;
			},
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		on: {
			init: function () {
				// Create live region for screen reader announcements
				const liveRegion = document.createElement('div');
				liveRegion.id = `${sliderId}-live-region`;
				liveRegion.className = 'sr-only';
				liveRegion.setAttribute('aria-live', 'polite');
				liveRegion.setAttribute('aria-atomic', 'true');
				swiperElement.appendChild(liveRegion);

				// Set initial states
				this.navigation.update();
			},

			slideChange: function () {
				// Update pagination buttons
				const bullets = this.pagination.bullets;
				bullets.forEach((bullet, index) => {
					const isActive = index === this.realIndex;
					bullet.setAttribute('aria-selected', isActive ? 'true' : 'false');
					bullet.setAttribute('aria-current', isActive ? 'true' : '');
				});

				// Update navigation buttons
				const isBeginning = this.isBeginning;
				const isEnd = this.isEnd;

				const prevButton = section.querySelector('.slider-button-prev');
				const nextButton = section.querySelector('.slider-button-next');

				// Update previous button state
				if (prevButton) {
					prevButton.disabled = isBeginning;
					prevButton.setAttribute('aria-disabled', isBeginning);
				}

				// Update next button state
				if (nextButton) {
					nextButton.disabled = isEnd;
					nextButton.setAttribute('aria-disabled', isEnd);
				}

				// Announce slide change to screen readers
				const liveRegion = document.getElementById(`${sliderId}-live-region`);
				if (liveRegion) {
					const currentSlide = this.realIndex + 1;
					const totalSlides = this.slides.length;
					liveRegion.textContent = `Slide ${currentSlide} van ${totalSlides}`;
				}
			},
		},
	});
});
